import { toast } from "react-hot-toast";
import styled from "styled-components";

export function toastSuccess(message) {
  toast.success(message, {
    position: "top-right",
    duration: 3000,
  });
}

export function toastError(message) {
  toast.error(message, {
    position: "top-right",
    duration: 3000,
  });
}

export function toastIcon(icon, message) {
  toast(message, { icon });
}

export function toastQuestion(question) {
  /* toast(question, { position: "top-left", duration: 15000, icon: "🙋" }); */
  toast(
    (t) => (
      <QuestionToast>
        <div className="h-100 d-flex flex-column justify-content-center me-2">
          <i className="fa fa-question" />
        </div>
        <div className="d-flex flex-column">
          <b className="float-right">
            {question.sender.firstName} {question.sender.lastName}
          </b>
          <span>{question.text}</span>
        </div>
      </QuestionToast>
    ),
    { position: "top-left", duration: 15000, style: { border: "3px solid #0000ff" } }
  );
}

const QuestionToast = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 1.25rem !important;

  i {
    color: rgba(0, 0, 255, 1);
    font-size: 2.5rem;
  }
`;
